import React from 'react';
import { func } from 'prop-types';
import { Route, Redirect, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import variables
import { APP_CORE_PATHS } from 'components/routes/paths';

const { REGISTER, ADDITIONAL_INFO, DOCUMENT } = APP_CORE_PATHS;

const ProtectedRegistrationCompleted = ({ component: Component }) => {
	const { isAuthenticated, isRegisterCompleted, isFirebaseRegisterCompleted } =
		useSelector(({ auth }) => auth);

	const checkIsDocument = (pathname) =>
		matchPath(pathname, { path: `/${DOCUMENT}` });

	return (
		<Route
			render={(props) =>
				isAuthenticated &&
				!isRegisterCompleted &&
				!isFirebaseRegisterCompleted &&
				// eslint-disable-next-line react/prop-types
				!checkIsDocument(props.location.pathname) ? (
					<Redirect to={`/${REGISTER}/${ADDITIONAL_INFO}`} />
				) : (
					<Component {...props} />
				)
			}
		/>
	);
};

ProtectedRegistrationCompleted.propTypes = {
	component: func.isRequired
};

export default ProtectedRegistrationCompleted;
